/**
 * FileStorageType
 */
export enum FileStorageType {
    IMAGE = 'image',
    AUDIO = 'audio',
    VIDEO = 'video',
    FILE = 'file'
}
